module.exports = __webpack_public_path__ + "media/landing_page/why-shoppers-pp-1-889dcad0.jpg";